










import { computed, defineComponent, toRefs } from '@nuxtjs/composition-api'
import CDynamicIcon from '~/components/shared/configurable/icon/CDynamicIcon.vue'
import { ciBoatAlt } from '~/icons/source/regular/boat-alt'
import { ciBusAlt } from '~/icons/source/regular/bus-alt'
import { ciTrain } from '~/icons/source/regular/train'
import { ciAirplane } from '~/icons/source/regular/airplane'

export default defineComponent({
  components: { CDynamicIcon },
  props: {
    option: {
      type: Object,
      required: true
    },
    focused: {
      type: Boolean,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const { option } = toRefs(props)
    const icon = computed(() => {
      switch (option.value.value) {
        case 'delivery_to_port': {
          return ciBoatAlt
        }
        case 'delivery_to_bus_station': {
          return ciBusAlt
        }
        case 'delivery_to_train_station': {
          return ciTrain
        }
        case 'delivery_to_airport': {
          return ciAirplane
        }
        default: {
          return null
        }
      }
    })

    return { icon }
  }
})
